module.exports = __webpack_public_path__ + "static/img/icon3.c88d1729.png";